import React from 'react';
import OwnerPcpStat from './OwnerPcpStat';
import DownloadablePcpStat from './DownloadablePcpStat';
import PurchasablePcpStat from './PurchasablePcpStat';
var PcpStat = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, deviationId = _b.deviationId, _c = _b.extended, _d = _c === void 0 ? {} : _c, pcp = _d.pcp, editUrl = _d.editUrl, isOwner = _a.isOwner;
    if (!pcp) {
        return null;
    }
    if (isOwner) {
        return React.createElement(OwnerPcpStat, { editUrl: editUrl });
    }
    if (pcp.hasUserPurchased) {
        return React.createElement(DownloadablePcpStat, { deviationId: deviationId, url: pcp.url });
    }
    return React.createElement(PurchasablePcpStat, { deviation: deviation });
};
export default PcpStat;
//# sourceMappingURL=PcpStat.js.map